import React from 'react'
import ToDoList from '../components/ToDoList'
const Body = () => {
  return (
    <div>
      
        <ToDoList />
              
    </div>
  )
}

export default Body